import { useRef } from "react";

interface Timers {
  // [startTime, endTime, durationInMs]
  [key: string]: [number, number | null, number | null];
}

const useDuration = () => {
  const durationRef = useRef<Timers>({});

  /**
   * Starts the timer by setting starting timestamp.
   * If no key is provided DEFAULT timer will run.
   * @param key timer name
   */
  const startTimer = (key: string = "DEFAULT"): void => {
    durationRef.current[key] = [Date.now(), null, null];
  };

  /**
   * Takes the current timestamp and subtracts the starting timestamp.
   * @returns duration in ms
   */
  const pauseTimer = (key: string = "DEFAULT"): number | null => {
    // check if timer is there for given key
    if (durationRef.current[key]?.length === 3) {
      const [startTime] = durationRef.current[key];
      const newEndTime = Date.now();
      const newDuration = newEndTime - startTime;
      durationRef.current[key] = [startTime, newEndTime, newDuration];
      return isNaN(newDuration) ? null : newDuration;
    }
    return null;
  };

  /**
   * Resets the timer.
   */
  const clearTimer = (key: string = "DEFAULT", clearAll: boolean = false) => {
    if (clearAll) {
      durationRef.current = {};
    } else {
      delete durationRef.current[key];
    }
  };

  return {
    startTimer,
    pauseTimer,
    clearTimer,
    durationRef
  };
};

export default useDuration;
